import { t } from "i18next";
import React from "react";
import cx from "clsx";
import { getShippingCostDisplayText } from "../../../utils/getShippingCostDisplayText";
import { useOrderData } from "../../../providers/orderDataStore";
import { useConfig } from "../../../providers/config";
import { useGetDeliveryShippingFeePerKg } from "../../../hooks/useGetDeliveryShippingFeePerKg";

export const ShippingCost = () => {
  const config = useConfig();
  const extraWeightFee = config.extraWeightFee ?? 0;
  const maxWeightForFeeKG = config.maxWeightForFeeKG ?? 0;

  const { shippingMethod } = useOrderData();
  const currentShippingCost = shippingMethod?.cost ?? "0";

  const feePerKg = useGetDeliveryShippingFeePerKg();
  const isDeliveryFree = currentShippingCost === "0" && feePerKg === 0;

  const shippingCostDisplayText = getShippingCostDisplayText({
    shippingMethodCost: currentShippingCost,
    feePerKg,
  });

  return (
    <div className="flex items-center justify-between px-2.5 py-5 border-b-1 border-gray-200">
      <div className="flex flex-col gap-1">
        <div className=" text-[#292929]">{t("Shipping Cost")}</div>
        {feePerKg > 0 && (
          <div className="text-xs text-[#292929]">
            {t("Weight fee explanation", {
              maxWeight: maxWeightForFeeKG,
              step: config.maxWeightFeeStep,
              fee: extraWeightFee,
            })}
          </div>
        )}
      </div>
      <div className="flex justify-center items-center gap-2">
        <span className={cx("text-sm text-purple-", isDeliveryFree && "font-bold text-primary")}>
          {shippingCostDisplayText}
        </span>
      </div>
    </div>
  );
};
